export enum OamQuestionId {
  FirstApplicantSelfEmployedType = 'FirstApplicantSelfEmployedType',
  FirstApplicantBvAmount = 'FirstApplicantBvAmount'
}
